/* Core & libraries */
import React, { useState, useRef, useEffect } from "react";
import { useTheme } from "react-jss";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import { ErrorMessage, Field, Formik } from "formik";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import UCButton from "../../buttons";

/* Helpers, constants, custom methods, internal libraries */
import {
  createValidationPolicyYupSchema,
  useValidationService
} from "../../../resources/validations/validations";
import {useCompaniesService} from "../../../services/companiesService";

/* Components */
import MultiValueField from "components/ucMultiValueField";

/* Styles */
import styles from "./styles.js"


const messages = defineMessages({
  citiPcanPlaceholderMessage: {
    id: 'editCitiPcanModal.placeholder'
  },
})

const Content = props => {
  const { setShowModal, entityPCAN, companyEntityId, setEntityField, entityPCANLimit } = props;

  const theme = useTheme();
  const classes = styles({ theme });

  const formRef = useRef(null);
  const intl = useIntl();

  const { updateCitiPCANMockedApiValidationObj } = useValidationService()
  const [testSchema, setTestSchema] = useState({});
  const {updateCompanyCitiPCAN} = useCompaniesService()
  const [exitingEntityPCAN, setExitingEntityPCAN] = useState(false)

  useEffect(() => {
    //TODO: api call to get validations //simpleMockedApiValidationObj
    const result = createValidationPolicyYupSchema(updateCitiPCANMockedApiValidationObj);
    setTestSchema(result)
  }, [])

  const handleFormSubmit = () => {
    if (formRef.current) {
      formRef.current.handleSubmit()
    }
  }

  const submitForm = async (values, setSubmitting) => {
    const response = await updateCompanyCitiPCAN(values, companyEntityId)
    if (response.status === "ERROR") {
      const errorCode = response?.errors[0]?.errorCode;
      if (errorCode === '1995') {
        setExitingEntityPCAN(true)
      }
    } else if (response.status === "SUCCESS") {
      setShowModal(false)
      setSubmitting(false);
      setEntityField(values.entityPCAN)
    }
  }
  const entityPCANChange = (item, setFieldValue) => {
    setExitingEntityPCAN(false)
    setFieldValue("entityPCAN", item);
  };

  const maxPCANsAllowed = parseInt(entityPCANLimit) || 2

  return (
    <div className={classes.modalContent}>
      <Formik
        innerRef={formRef}
        initialValues={{
          entityPCAN: entityPCAN || []
        }}
        validationSchema={testSchema}
        onSubmit={(values, { setSubmitting }) => {
          submitForm(values, setSubmitting);
        }}
      >
        {({
            values,
            errors,
            touched,
            setFieldTouched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue
          }) => (

          <>
            <form onSubmit={handleSubmit} >
              <div className={classes.inputContainer}>
                <label htmlFor="entityPCAN" className={classes.label}>
                  <FormattedMessage id="editCitiPcanModal.label"/>
                </label>
                <MultiValueField
                  name="entityPCAN"
                  values={values.entityPCAN}
                  onValuesChange={item => entityPCANChange(item, setFieldValue)}
                  setFieldTouched={setFieldTouched}
                  placeholder={intl.formatMessage(messages.citiPcanPlaceholderMessage)}
                  maxValues={maxPCANsAllowed}
                  errors={errors}
                  ariaDescribedby={"entityPCAN-error"}
                />
                <ErrorMessage
                  name="entityPCAN"
                  component="span"
                  className={classes.error}
                  id="entityPCAN-error"
                  role="alert"
                  aria-live="assertive"
                />
                {exitingEntityPCAN && (
                  <div className={classes.nameError}>
                    <FormattedMessage id="editCitiPCANsModal.primaryErrorMessageText" />
                  </div>
                )}
              </div>
              <div className={classes.btnContainer}>
                <ContainerFluid>
                  <Row>
                    <Col className={classes.colCancel}>
                      <UCButton
                        onClick={() => setShowModal(false)}
                        type="default"
                        className={classes.cancelBtn}
                        text={<FormattedMessage id="editCitiPcanModal.cancel"/>}
                      />
                    </Col>
                    <Col className={classes.colRemove} >
                      <UCButton
                        className={classes.createBtn}
                        onClick={handleFormSubmit}
                        type="primary"
                        text={<FormattedMessage id="editCitiPcanModal.save"/>}
                        spinner={{
                          name: "updateCompanyPCANSpinner",
                          size: 20,
                        }}
                      />
                    </Col>
                  </Row>
                </ContainerFluid>
              </div>
            </form>
          </>
        )}
      </Formik>
    </div>
  )
}

export default Content;